import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { GlassCard } from './GlassCard';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  index?: number;
}

export function StatCard({ title, value, subtitle, icon, trend, className, index = 0 }: StatCardProps) {
  return (
    <GlassCard className={cn('relative overflow-hidden h-full animate-stat-in hover-lift', className)} style={{ animationDelay: `${index * 80}ms` }}>
      <div className="flex items-start justify-between h-full">
        <div className="flex flex-col">
          <p className="text-sm text-gray-400 mb-1">{title}</p>
          <p className="text-3xl font-bold text-white tracking-tight">{value}</p>
          <p className="text-sm text-gray-500 mt-1 min-h-[20px]">{subtitle || '\u00A0'}</p>
          {trend && (
            <div className={cn('flex items-center gap-1 mt-2 text-sm', trend.isPositive ? 'text-primary-400' : 'text-red-400')}>
              <span>{trend.isPositive ? '↑' : '↓'}</span>
              <span>{Math.abs(trend.value)}%</span>
              <span className="text-gray-500">vs last month</span>
            </div>
          )}
        </div>
        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center text-primary-400 flex-shrink-0">
          {icon}
        </div>
      </div>
      <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary-500/5 rounded-full blur-2xl" />
    </GlassCard>
  );
}
